namespace SPA {
	import StatusList = SPA.Contacts.StatusList;

	export interface IContact {
		ContactID?: number;
		Salutation?: string;
		Title?: string;
		Name?: string;
		Surname?: string;
		Rating?: string;
		Birthdate?: string;

		Street?: string;
		HouseNumber?: string;
		PostalCode?: string;
		City?: string;
		State?: string;

		Email?: string;
		Fax?: string;
		Mobile?: string;
		Phone?: string;
		Notes?: string;

		Demand?: {};
		// Status is NOT used directly, just for type-safety to build the statuslist
		Status?: ContactStatus[];
		StatusList: SPA.Contacts.StatusList;
		Adviser?: ContactStatus;

		CreatedAt: string;
		DeletedAt: string;

		// [key: string]: any;
	}

	export class Contact extends Backbone.Model implements IContact {
		// [key: string]: any;

		public constructor(attributes?: IContact, options?: any) {
			if (options === undefined) {
				options = {};
			}

			super(attributes, options);
		}

		get ContactID(): number {
			return this.get('ContactID') || 0;
		}

		set ContactID(ContactID: number) {
			this.set('ContactID', ContactID);
		}

		get Salutation(): string {
			return this.get('Salutation') || '';
		}

		set Salutation(Salutation: string) {
			this.set('Salutation', Salutation);
		}

		get Title(): string {
			return this.get('Title') || '';
		}

		set Title(Title: string) {
			this.set('Title', Title);
		}

		get Name(): string {
			return this.get('Name') || '';
		}

		set Name(Name: string) {
			this.set('Name', Name);
		}

		get Surname(): string {
			return this.get('Surname') || '';
		}

		set Surname(Surname: string) {
			this.set('Surname', Surname);
		}

		get Street(): string {
			return this.get('Street') || '';
		}

		set Street(Street: string) {
			this.set('Street', Street);
		}

		get HouseNumber(): string {
			return this.get('HouseNumber') || '';
		}

		set HouseNumber(HouseNumber: string) {
			this.set('HouseNumber', HouseNumber);
		}

		get PostalCode(): string {
			return this.get('PostalCode') || '';
		}

		set PostalCode(PostalCode: string) {
			this.set('PostalCode', PostalCode);
		}

		get Birthdate(): string {
			return this.get('Birthdate') || '';
		}

		set Birthdate(Birthdate: string) {
			this.set('Birthdate', Birthdate);
		}

		get Notes(): string {
			return this.get('Notes') || '';
		}

		set Notes(Notes: string) {
			this.set('Notes', Notes);
		}

		get City(): string {
			return this.get('City') || '';
		}

		set City(City: string) {
			this.set('City', City);
		}

		get State(): string {
			return this.get('State') || '';
		}

		set State(State: string) {
			this.set('State', State);
		}

		get Email(): string {
			return this.get('Email') || '';
		}

		set Email(Email: string) {
			this.set('Email', Email);
		}

		get Fax(): string {
			return this.get('Fax') || '';
		}

		set Fax(Fax: string) {
			this.set('Fax', Fax);
		}

		get Mobile(): string {
			return this.get('Mobile') || '';
		}

		set Mobile(Mobile: string) {
			this.set('Mobile', Mobile);
		}

		get Phone(): string {
			return this.get('Phone') || '';
		}

		set Phone(Phone: string) {
			this.set('Phone', Phone);
		}

		get Demand(): any {
			return this.get('Demand');
		}

		set Demand(Demand: any) {
			this.set('Demand', Demand);
		}

		get Status(): SPA.ContactStatus[] {
			return this.get('Status');
		}

		set Status(Status: SPA.ContactStatus[]) {
			this.set('Status', Status);
		}

		get StatusList(): SPA.Contacts.StatusList {
			return this.get('StatusList');
		}

		set StatusList(List: SPA.Contacts.StatusList) {
			this.set('StatusList', List);
		}

		get Adviser(): ContactStatus {
			return this.get('Adviser');
		}

		set Adviser(Adviser: ContactStatus) {
			this.set('Adviser', Adviser);
		}

		get CreatedAt(): string {
			return this.get('CreatedAt');
		}

		set CreatedAt(CreatedAt: string) {
			this.set('CreatedAt', CreatedAt);
		}

		get DeletedAt(): string {
			return this.get('DeletedAt');
		}

		set DeletedAt(DeletedAt: string) {
			this.set('DeletedAt', DeletedAt);
		}

		public completeAddress(): string {
			return this.Street + ' ' + this.HouseNumber + ', ' + this.PostalCode + ' ' + this.City + ', ' + this.getStateMapped();
		}

		public completeName(): string {
			return this.getSalutationMapped() + ' ' + this.Title + ' ' + this.Name + ' ' + this.Surname;
		}

		public statusList(): string {
			// return this.StatusList.assignments();
			const list = this.StatusList.map((status: ContactStatus) => {
				return SPA.types.Address.Type[status.Name as keyof typeof SPA.types.Address.Type];
			});

			return _.union(list).sort().join(', ');
		}

		public createTimestamp(): number {
			return moment(this.CreatedAt).format('X');
		}

		public createDate(): string {
			return moment(this.CreatedAt).format('DD.MM.YYYY - HH:mm') + ' Uhr';
		}

		public isExclusiveBidder(): boolean {
			return this.isExclusiveStatus('bidder');
		}

		public isEmptyStatus(): boolean {
			let isEmpty: boolean = true;
			const status: string[] = ['owner', 'seller'];

			status.forEach((stat) => {
				if (this.StatusList.where({Name: stat as IContactStatusName}).length > 0) {
					isEmpty = false;
					return isEmpty;
				}
			});
			return isEmpty;
		}

		public isExclusiveStatus(name: IContactStatusName): boolean {
			return this.StatusList.where({Name: name}).length === 1 || this.StatusList.where({Name: name}).length === 0;
		}

		public getSalutationMapped(): string {
			return this.Salutation ? SPA.types.Salutation[this.Salutation as keyof typeof SPA.types.Salutation] : '';
		}

		public getStateMapped(): string {
			return this.State ? SPA.types.Address.State[this.State as keyof typeof SPA.types.Address.State] : '';
		}

		public preinitialize(attributes?: IContact, options?: any): void {
			this.idAttribute = 'ContactID';
		}

		public defaults(): IContact {
			return {
				ContactID: 0,
				Salutation: '',
				Title: '',
				Name: '',
				Surname: '',

				Street: '',
				HouseNumber: '',
				PostalCode: '',
				City: '',
				State: '',

				Email: '',
				Fax: '',
				Mobile: '',
				Phone: '',
				Notes: '',

				Demand: {},
				Status: [],
				StatusList: new SPA.Contacts.StatusList(),
				Adviser: undefined,

				CreatedAt: '',
				DeletedAt: '',
			};
		}

		public link(object_number: string, name: IContactStatusName, callback?: (data: ContactStatus) => any)
		{
			const statusList = this.StatusList.findStatus({name, object_number});
			if (!statusList || statusList.length === 0)
			{
				new Wollmilch.AJAX({
					url: 'contact/link/' + this.ContactID + '/' + btoa(object_number),
					method: 'POST',
					data: {status: [name]},
					on: {
						success: (text) => {
							const response = JSON.parse(text);

							if (!response.success) {
								app.addNotify(
									{
										context: "danger",
										body: [$('<p>Fehler beim Zuweisen des Kontaktes.<br><strong>' + response.error.code + '</strong></p>')],
										timeout: Number(app.getConfigValue("ToastTimeout")),
										title: ['Fehler bei Kontaktzuweisung']
									}
								);
								return false;
							}

							const newStatus = new ContactStatus(response.data[0]);
							this.StatusList.add(newStatus);

							if (callback)
							{
								callback(newStatus);
							}
						}
					}
				}, AJAXCallbase_e.REALTOR).send();
			}
		}

		public unlink(StatusID: number, callback?: (done: boolean) => any) {
			new Wollmilch.AJAX({
				url: 'contact/unlink/' + this.ContactID + (StatusID ? '/' + StatusID : ''),
				method: 'DELETE',
				on: {
					success: (text) => {
						const response = JSON.parse(text);

						if (response.success === false) {
							alert('Fehler beim Aktualisieren der Anlage');
							return;
						}

						const oldStatus = this.StatusList.get(StatusID);
						this.StatusList.remove(oldStatus);

						if (callback) {
							callback(response.success);
						}
					}
				}
			}, AJAXCallbase_e.REALTOR).send();
		}

		public initialize(attributes?: IContact, options?: any): void
		{
			this.initStatusList();

			// Backbone doesn't support events for nested models/collections, emulate this behavior
			this.listenTo(this.StatusList, 'change remove', (model: SPA.ContactStatus, collection: StatusList, xhr: JQuery.jqXHR) =>
			{
				this.trigger('change:StatusList', this, collection, options);
				this.trigger('change', this, options);
			});
		}

		private initStatusList() {
			if (!this.Status) {
				return;
			}

			// Replace array with according class
			for (const statusObj of this.Status) {
				const status = new ContactStatus(statusObj);
				this.StatusList.add(status, {silent: true});
			}
		}
	}
}
